import { useMemo } from "react";

import { PrintItemTBodyLayout, PrintItemTHeadLayout, PrintSectionLayout } from "../../layout";

type Props = {
	isDayTrip: boolean;
	name?: string;
	// ホストが上書きした金額
	hostInsertedPrice?: number;
	// ディスカウントされた金額
	discountedPrice?: number;
	// 通常金額
	price?: number;
};

export const PlanOfPrintComposition = ({ isDayTrip, name, hostInsertedPrice, discountedPrice, price = 0 }: Props) => {
	const planTypeText = useMemo(() => (isDayTrip ? "日帰り" : "プラン"), [isDayTrip]);
	const planNameText = useMemo(() => name ?? "選択なし", [name]);
	/**
	 * 順に優先度が高い
	 */
	const actualPrice = useMemo(
		() => hostInsertedPrice ?? discountedPrice ?? price,
		[discountedPrice, hostInsertedPrice, price],
	);

	return (
		<PrintSectionLayout titleChildren={<p className="text-sm font-bold">プラン</p>}>
			<div>
				<PrintItemTHeadLayout />

				<PrintItemTBodyLayout free={planTypeText} name={planNameText} price={price} actualPrice={actualPrice} />
			</div>
		</PrintSectionLayout>
	);
};
